module.exports = __webpack_public_path__ + "img/logo.35c8c136.png";